import React, { useEffect } from "react";

import logo from "../../assets/images/logo/global-assistance-logo.png";
import "./maintenance.css";

const Maintenance = () => {
  useEffect(() => {
    document.title = "Bakım Çalışması | Global Yol Yardım";
  }, []);

  return (
    <main className="maintenance-page">
      <div className="maintenance-accent" aria-hidden="true" />

      <section className="maintenance-content" aria-labelledby="maintenance-title">
        <img
          className="maintenance-logo"
          src={logo}
          alt="Global Yol Yardım"
        />

        <div className="maintenance-status" aria-hidden="true">
          <i className="ri-tools-line" />
        </div>

        <p className="maintenance-label">PLANLI BAKIM ÇALIŞMASI</p>
        <h1 id="maintenance-title">Kısa bir mola verdik.</h1>
        <p className="maintenance-description">
          Size daha iyi hizmet verebilmek için sistemlerimizde bakım çalışması
          gerçekleştiriyoruz. Çok yakında yeniden hizmetinizde olacağız.
        </p>

        <div className="maintenance-notice" role="status">
          <i className="ri-time-line" aria-hidden="true" />
          <span>Anlayışınız ve sabrınız için teşekkür ederiz.</span>
        </div>
      </section>

      <footer className="maintenance-footer">
        <span>Global Yol Yardım</span>
        <span aria-hidden="true">•</span>
        <span>7/24 yanınızda</span>
      </footer>
    </main>
  );
};

export default Maintenance;
